<template>
  <div class="m-0" id="expired">
    <div class="card block relative max-w-lg mt-12 mx-auto p-8 text-center box-border rounded-lg">
      <h2 class="mt-20 mx-0 mb-4">
        {{ $t('AssessmentExpiredComponent.expired') }}</h2>
      <i>
        <font-awesome-icon class="text-[var(--color-orange)] my-12 mx-0 text-9xl"
             icon="fa-regular fa-clock" />
      </i>
      <p></p>
      <Button @click.prevent="navigateToHome" type="button" name="submit" id="btn_submit"
                class="py-2 px-9 my-20 mx-4 text-lg w-48 h-12 border-none
                text-[var(--color-white)] rounded-full bg-[var(--color-orange)]
                transition duration-500 hover:bg-[var(--color-fulvous)] " unstyled>
          {{ $t('AssessmentExpiredComponent.backHome') }}
      </Button>
    </div>
  </div>
</template>

<script>
import { Button } from 'primevue';

export default {
  name: 'AssessmentExpiredComponent',
  components: { Button },
  methods: {
    navigateToHome() {
      this.$router.push('/');
    },
  },
  unmounted() {
    this.$store.commit('setIsExpired', true);
  },
};
</script>
